import type { HelpPortalSource } from "@/lib/help-portal";
import {
  TITLE_HELP_ARTICLES,
  TITLE_HELP_CATEGORIES,
  getTitleHelpArticle,
  isTitleHelpArticleId,
  titleArticlesInCategory,
} from "@/lib/title-help/articles";
import { searchTitleHelpArticles } from "@/lib/title-help/search";

export const TITLE_HELP_PORTAL: HelpPortalSource = {
  articles: TITLE_HELP_ARTICLES,
  categories: TITLE_HELP_CATEGORIES,
  searchArticles: searchTitleHelpArticles,
  articlesInCategory: titleArticlesInCategory,
  indexTo: "/title/help",
  articleTo: "/title/help/$articleId",
  emptySearchHint: "Try request, status, users, or account.",
};

export function isTitleHelpPath(pathname: string): boolean {
  return pathname === "/title/help" || pathname.startsWith("/title/help/");
}

export { TITLE_HELP_ARTICLES, getTitleHelpArticle, isTitleHelpArticleId };
